import React, { useState } from "react";
import './Projects.css';

export const Projects = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const solarProjects = [
    {
      title: "Residential Solar Installation",
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600&q=80"
    },
    {
      title: "Commercial Solar Array",
      image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600&q=80"
    },
    {
      title: "Solar Farm Project",
      image: "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600&q=80"
    },
    {
      title: "Rooftop Solar Panels",
      image: "https://images.unsplash.com/photo-1541167760496-1628856ab772?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600&q=80"
    },
    {
      title: "Solar Water Heating System",
      image: "https://images.unsplash.com/photo-1597239450996-ea7c2c564412?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600&q=80"
    },
    {
      title: "Industrial Solar Solution",
      image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600&q=80"
    }
  ];

  const openModal = (project) => {
    setSelectedImage(project);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div id="portfolio" className="text-center solar-gallery">
      <div className="container">
        <div className="section-title">
          <h2>Our Solar Projects</h2>
          <p>
            Explore our successful solar installations across residential, commercial, and industrial sectors
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {solarProjects.map((project, i) => (
              <div
                key={`${project.title}-${i}`}
                className="col-sm-6 col-md-4 col-lg-4 mb-4"
              >
                <div 
                  className="gallery-item"
                  onClick={() => openModal(project)}
                >
                  <img
                    src={project.image}
                    alt={project.title}
                    className="img-fluid"
                  />
                  <div className="gallery-overlay">
                    <div className="gallery-caption">
                      <h4>{project.title}</h4>
                      <div className="view-btn">View Project</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="gallery-modal" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>
              &times;
            </button>
            <img 
              src={selectedImage.image} 
              alt={selectedImage.title} 
              className="modal-image"
            />
            <div className="modal-caption">
              <h3>{selectedImage.title}</h3>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};